import React from "react";
import { Typography } from "@material-ui/core";
import { workflowSelectionHeaderStyles } from "../styles";

interface WorkflowSelectionHeaderProps {
  title: string;
  subtitle: string;
}

const WorkflowSelectionHeader: React.FC<WorkflowSelectionHeaderProps> = ({
  title,
  subtitle,
}) => {
  return (
    <div style={workflowSelectionHeaderStyles.container}>
      <Typography variant="h4" style={workflowSelectionHeaderStyles.title}>
        {title}
      </Typography>
      <Typography
        variant="body1"
        style={workflowSelectionHeaderStyles.subtitle}
      >
        {subtitle}
      </Typography>
    </div>
  );
};

export default WorkflowSelectionHeader;
